import { render, staticRenderFns } from "./StaffKpi.vue?vue&type=template&id=2d860366&scoped=true"
import script from "./StaffKpi.vue?vue&type=script&lang=js"
export * from "./StaffKpi.vue?vue&type=script&lang=js"
import style0 from "./StaffKpi.vue?vue&type=style&index=0&id=2d860366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d860366",
  null
  
)

export default component.exports